import StorePage from '../../components/pages/Store';

const StoreBlock: React.FC = () => {
  return <StorePage isBlockStoresView={true} />;
};

export default StoreBlock;
